import * as React from 'react'
import { colours } from '../../../config/theme'
import IconType from '../../../general/Icon/iconTypes'
import ModuleCard from './ModuleCard'

export const DocumentsModuleCard = () => (
  <ModuleCard
    backgroundColor={colours.status.popout}
    icon={IconType.DocsHexagon}
    link="/organisation/documents"
    linkText="Find out more"
    subtitle="Store all your important documents in one central location."
    title="Policies"
  />
)
